var React = require('react');

function Refresh (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.64 2.85A7.958 7.958 0 0 0 7.99.5C3.57.5 0 4.08 0 8.5s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08a5.99 5.99 0 0 1-5.65 4c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L8.99 7.5h7v-7l-2.35 2.35z","fill":"currentColor","fillRule":"evenodd"}));
}

Refresh.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17"};

module.exports = Refresh;

Refresh.default = Refresh;
